module.exports = __webpack_public_path__ + "88bcd2a92e29a9310516827d4aefd057.svg";